import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'

import { Form, Select, ColorPicker } from 'components/forms'
import { ImageUploaderGraphql } from 'components/Image'
import { ContentBlock, ExpandableBlocks, ExpandableContext } from 'components/ContentBlock'
import { getProduct } from '../../gql/query'
import { useMutation, useQuery } from 'components/graphql'
import { updateProductProperties } from '../../gql/mutation'
import { Fonts, FontStyle, FontSize } from './fieldsOptions'
import updateProperties from '../../fragments/mutateProductProperties'

import { FormField } from './StyledComponents'
import styles from 'style/app.module.scss'
import { getKitchenTimeSlots } from 'gql/query'

const Presentation = ({ data = {}, formData, itemId }) => {
	const [t] = useTranslation()

	const { data: queryData, queryField } = useQuery(getKitchenTimeSlots)
	const slotsOptions = get(queryData, [queryField, 'cashRegisterGlobal', 'kitchenTimeSlots'], [])
		.map(({ timeSlotCode, name }) => ({ value: timeSlotCode, label: name }))

	const imgKey = get(data, ['img', 'key'])
	const imgKeyKiosk = get(data, ['imgKiosk', 'key'])

	const [mutate] = useMutation(updateProductProperties)

	return(
		<Form
			initialValues={formData}
			onSubmit={({ properties }) => updateProperties({ productId: data.id, ...properties }, mutate)}
			smartSubmit
			className={styles['flex-cols']}
		>
			<ExpandableBlocks>
				<ExpandableContext.Consumer>
					{({ expandedId }) => (
						<>
							<ContentBlock alwaysExpanded style={{ flexGrow: expandedId === '1' || typeof expandedId === 'undefined' ? 0 : 1 }}>
								<Row>
									<Col xs className='narrow-col'>
										<FormField>
											<ColorPicker
												field='properties.ColorFont'
												label={t('product_section.fields.color')}
											/>
										</FormField>
										<ColorPicker
											field='properties.Color'
											label={t('product_section.fields.background_color')}
										/>
									</Col>
									<Col xs>
										<Select
											field='properties.FontStyle'
											label={t('product_section.fields.style')}
											options={FontStyle(t)}
										/>
										<Select
											label={t('options_section.strings.time_ranges_for_unattended_systems')}
											field='properties.SCOProductTimeSlot'
											options={slotsOptions}
											isClearable
										/>
									</Col>
									<Col xs>
										<Select
											field='properties.Font'
											label={t('product_section.fields.font')}
											options={Fonts}
											isClearable
										/>
										<Select
											field='properties.FontSize'
											label={t('product_section.fields.size')}
											options={FontSize}
											isClearable
										/>
									</Col>
								</Row>
							</ContentBlock>
							<ContentBlock startExpanded label='Bild' blockId='1'>
								<Row>
									<Col xs>
										<ImageUploaderGraphql
											getQuery={getProduct}
											id={itemId}
											parent='Product'
											type='Product'
											imgKey={imgKey}
											label={t('product_section.fields.cash_register_image')}
											width={256}
											height={256}
											elementMaxWidth={300}
										/>
									</Col>
									<Col xs>
										<ImageUploaderGraphql
											getQuery={getProduct}
											id={itemId}
											field='imgKiosk'
											parent='Product'
											type='ProductKiosk'
											imgKey={imgKeyKiosk}
											label={t('product_section.fields.selfcheckout_image')}
											width={800}
											height={800}
											elementMaxWidth={300}
										/>
									</Col>
								</Row>
							</ContentBlock>
						</>
					)}
				</ExpandableContext.Consumer>
			</ExpandableBlocks>
		</Form>
	)
}

export default Presentation
